export type Category = "technical" | "hr" | "business" | "opportunities";
export interface Job {
 title: string; category: Category; slug: string; location: string;
 qualification: string; sourceUrl: string; description: string[]; sections: { title: string; items: string[] }[];
}
export const jobs: Job[] = [
  {
    "title": "Physical Design Engineer",
    "category": "technical",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "physical-design-engineer",
    "sourceUrl": "https://www.digicommsemi.com/physical-design-engineer.html",
    "description": [
      "Physical Design Planning:Collaborate with chip architects and logic designers to understand the design goals, constraints, and specifications. Develop a physical design plan that outlines the steps and resources needed for successful implementation.",
      "Floorplanning: Create a floorplan that defines the placement of different functional blocks and components on the semiconductor die to optimize power, performance, and area (PPA).",
      "Placement: Place and optimize logic cells, memory elements, and other IP blocks on the chip according to the floorplan. Balance trade-offs between area, timing, and power consumption.",
      "Clock Tree Synthesis (CTS): Design and implement clock distribution networks to ensure synchronized clock signals throughout the chip, minimizing clock skew and jitter.",
      "Routing: Perform global and detailed routing to connect all the components on the chip while adhering to design rules and manufacturability constraints.",
      "Timing Closure: Use static timing analysis tools to meet timing requirements and ensure the chip operates at the desired clock frequency.",
      "Power Optimization: Implement low-power design techniques, such as power gating, voltage scaling, and clock gating, to reduce power consumption while maintaining performance",
      "Physical Verification: Run design rule checking (DRC) and layout versus schematic (LVS) checks to ensure the layout meets manufacturing and electrical integrity standards.",
      "Design for Manufacturing (DFM): Collaborate with manufacturing teams to optimize the design for the fabrication process, considering issues like lithography, yield, and process variations.",
      "Tape-out: Prepare the final design for fabrication by generating the required files and documentation. Coordinate with foundries for tape-out.",
      "Post-Silicon Validation Support: Assist in post-silicon bring-up and debugging, if necessary, to ensure the chip performs as expected.",
      "Documentation: Maintain detailed documentation of the design process, methodologies, and any issues encountered for future reference."
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Physical Design Planning:Collaborate with chip architects and logic designers to understand the design goals, constraints, and specifications. Develop a physical design plan that outlines the steps and resources needed for successful implementation.",
          "Floorplanning: Create a floorplan that defines the placement of different functional blocks and components on the semiconductor die to optimize power, performance, and area (PPA).",
          "Placement: Place and optimize logic cells, memory elements, and other IP blocks on the chip according to the floorplan. Balance trade-offs between area, timing, and power consumption.",
          "Clock Tree Synthesis (CTS): Design and implement clock distribution networks to ensure synchronized clock signals throughout the chip, minimizing clock skew and jitter.",
          "Routing: Perform global and detailed routing to connect all the components on the chip while adhering to design rules and manufacturability constraints.",
          "Timing Closure: Use static timing analysis tools to meet timing requirements and ensure the chip operates at the desired clock frequency.",
          "Power Optimization: Implement low-power design techniques, such as power gating, voltage scaling, and clock gating, to reduce power consumption while maintaining performance",
          "Physical Verification: Run design rule checking (DRC) and layout versus schematic (LVS) checks to ensure the layout meets manufacturing and electrical integrity standards.",
          "Design for Manufacturing (DFM): Collaborate with manufacturing teams to optimize the design for the fabrication process, considering issues like lithography, yield, and process variations.",
          "Tape-out: Prepare the final design for fabrication by generating the required files and documentation. Coordinate with foundries for tape-out.",
          "Post-Silicon Validation Support: Assist in post-silicon bring-up and debugging, if necessary, to ensure the chip performs as expected.",
          "Documentation: Maintain detailed documentation of the design process, methodologies, and any issues encountered for future reference."
        ]
      }
    ]
  },
  {
    "title": "Design Verification Engineers",
    "category": "technical",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "design-verification-engineer",
    "sourceUrl": "https://www.digicommsemi.com/design-verification-engineer.html",
    "description": [
      "Hands On Experience, in IP/SOC Verification",
      "Have Experience of one or more Project Cycles including Tape Outs",
      "Design & Verification Failure Debugging Skills",
      "Verilog, System Verilog, & UVM Testbench Coding",
      "Functional Coverage Development, & Coverage Closure",
      "Assertion/Checker Development",
      "Testcase Planning & Development Practical Knowledge of Protocols like: PCIe, Ethernet, CXL, USB, CAN, LIN, FlexRay, AXI, AHB, APB",
      "Concepts in Digital Design Problem Solving & Analytical Skills"
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Hands On Experience, in IP/SOC Verification",
          "Have Experience of one or more Project Cycles including Tape Outs",
          "Design & Verification Failure Debugging Skills",
          "Verilog, System Verilog, & UVM Testbench Coding",
          "Functional Coverage Development, & Coverage Closure",
          "Assertion/Checker Development",
          "Testcase Planning & Development Practical Knowledge of Protocols like: PCIe, Ethernet, CXL, USB, CAN, LIN, FlexRay, AXI, AHB, APB",
          "Concepts in Digital Design Problem Solving & Analytical Skills"
        ]
      }
    ]
  },
  {
    "title": "Analog Layout Engineer",
    "category": "technical",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "analog-layout-engineer",
    "sourceUrl": "https://www.digicommsemi.com/analog-layout-engineer.html",
    "description": [
      "Excellent work experience in Analog / Mixed Signal Layout design in advanced FinFET processes like 16nm, 12nm, 10nm, 7nm, 5nm, 3nm",
      "Expertise on complete PNR flow CTS,routing, Timing Closure.",
      "Hands on experience in any or multiple critical blocks such as SERDES, PHY, HDMI, PLL, ADC, DAC, LDO, Bandgap, Ref Generators, Charge Pump, Current Mirrors, Comparator, Differential Amplifier etc.",
      "Excellent understanding of CMOS / Bi-CMOS / SOI / FinFET process",
      "Excellent understanding of CMOS / Bi-CMOS / SOI / FinFET process",
      "Experience in AMS IP integration in full chip according to the guidelines demanded by the Full Chip needs",
      "Excellent problem-solving skills in Routing Congestion, Physical Verification in Custom Layout",
      "Sound knowledge and experience for verification checks like DRC / LVS / ERC / Antenna / LPE / DFM etc.",
      "Knowledge of various analog layout techniques, understanding of various circuit principles as affected by Layouts such as speed, capacitance, power, noise, and area",
      "Excellent hands-on experience in industry standard layout and verification tools in a Linux environment of Cadence and Mentor EDA tools. Power user of VirtuosoXL",
      "Excellent Leadership skills and Mentor & guide team members in execution of Layout and review their work outputs for quality and delivery",
      "Responsible for timely and quality execution of Custom Layout design",
      "Excellent communication skills and proactive at work"
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Excellent work experience in Analog / Mixed Signal Layout design in advanced FinFET processes like 16nm, 12nm, 10nm, 7nm, 5nm, 3nm",
          "Expertise on complete PNR flow CTS,routing, Timing Closure.",
          "Hands on experience in any or multiple critical blocks such as SERDES, PHY, HDMI, PLL, ADC, DAC, LDO, Bandgap, Ref Generators, Charge Pump, Current Mirrors, Comparator, Differential Amplifier etc.",
          "Excellent understanding of CMOS / Bi-CMOS / SOI / FinFET process",
          "Excellent understanding of CMOS / Bi-CMOS / SOI / FinFET process",
          "Experience in AMS IP integration in full chip according to the guidelines demanded by the Full Chip needs",
          "Excellent problem-solving skills in Routing Congestion, Physical Verification in Custom Layout",
          "Sound knowledge and experience for verification checks like DRC / LVS / ERC / Antenna / LPE / DFM etc.",
          "Knowledge of various analog layout techniques, understanding of various circuit principles as affected by Layouts such as speed, capacitance, power, noise, and area",
          "Excellent hands-on experience in industry standard layout and verification tools in a Linux environment of Cadence and Mentor EDA tools. Power user of VirtuosoXL",
          "Excellent Leadership skills and Mentor & guide team members in execution of Layout and review their work outputs for quality and delivery",
          "Responsible for timely and quality execution of Custom Layout design",
          "Excellent communication skills and proactive at work"
        ]
      }
    ]
  },
  {
    "title": "Physical Verification Engineers",
    "category": "technical",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "physical-verification-engineers",
    "sourceUrl": "https://www.digicommsemi.com/physical-verification-engineers.html",
    "description": [
      "Design Rule Checking (DRC): Run DRC checks using industry-standard tools to identify violations of manufacturing design rules. Collaborate with layout designers to resolve DRC issues.",
      "Layout vs. Schematic (LVS) Verification: Perform LVS checks to ensure that the physical layout accurately matches the schematic and that there are no electrical connectivity discrepancies.",
      "Electrical Rule Checking (ERC): Verify that the layout adheres to electrical constraints and requirements, such as voltage and current limitations, ensuring that the IC functions as intended.",
      "Design for Manufacturing (DFM): Collaborate with design and manufacturing teams to optimize the layout for the semiconductor fabrication process. Address lithography and process variation concerns.",
      "Process Technology Calibration: Calibrate layout extraction tools and parameters to match the specific process technology used for fabrication.",
      "Resolution Enhancement Techniques (RET): Implement RET techniques to improve the printability of layout patterns during the photolithography process.",
      "Fill Insertion: Insert fill cells into the layout to improve planarity and reduce manufacturing-related issues, such as wafer warping and stress.",
      "Multi-Patterning and Advanced Nodes: Deal with challenges specific to advanced process nodes, including multi-patterning, coloring, and metal stack variations.",
      "Hotspot Analysis: Identify and address potential hotspot areas that may lead to manufacturing defects or yield issues.",
      "Post-Processing Simulation: Perform post-processing simulations to verify that the layout is compatible with the manufacturing process and does not introduce unwanted parasitics.",
      "Process Integration Checks: Collaborate with process integration teams to ensure the smooth integration of the design with the semiconductor fabrication process.",
      "Documentation: Maintain detailed documentation of verification processes, methodologies, and results."
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Design Rule Checking (DRC): Run DRC checks using industry-standard tools to identify violations of manufacturing design rules. Collaborate with layout designers to resolve DRC issues.",
          "Layout vs. Schematic (LVS) Verification: Perform LVS checks to ensure that the physical layout accurately matches the schematic and that there are no electrical connectivity discrepancies.",
          "Electrical Rule Checking (ERC): Verify that the layout adheres to electrical constraints and requirements, such as voltage and current limitations, ensuring that the IC functions as intended.",
          "Design for Manufacturing (DFM): Collaborate with design and manufacturing teams to optimize the layout for the semiconductor fabrication process. Address lithography and process variation concerns.",
          "Process Technology Calibration: Calibrate layout extraction tools and parameters to match the specific process technology used for fabrication.",
          "Resolution Enhancement Techniques (RET): Implement RET techniques to improve the printability of layout patterns during the photolithography process.",
          "Fill Insertion: Insert fill cells into the layout to improve planarity and reduce manufacturing-related issues, such as wafer warping and stress.",
          "Multi-Patterning and Advanced Nodes: Deal with challenges specific to advanced process nodes, including multi-patterning, coloring, and metal stack variations.",
          "Hotspot Analysis: Identify and address potential hotspot areas that may lead to manufacturing defects or yield issues.",
          "Post-Processing Simulation: Perform post-processing simulations to verify that the layout is compatible with the manufacturing process and does not introduce unwanted parasitics.",
          "Process Integration Checks: Collaborate with process integration teams to ensure the smooth integration of the design with the semiconductor fabrication process.",
          "Documentation: Maintain detailed documentation of verification processes, methodologies, and results."
        ]
      }
    ]
  },
  {
    "title": "DFT Engineers",
    "category": "technical",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "dft-engineer",
    "sourceUrl": "https://www.digicommsemi.com/dft-engineer.html",
    "description": [
      "Should have good post silicon DFT bringup and debug experience.",
      "Hands on in multi-vendor DFT tools.",
      "Create test plan for complex ASICs and drive the DFT implementation.",
      "Ability to guide people, multiplex many issues and set priorities."
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Should have good post silicon DFT bringup and debug experience.",
          "Hands on in multi-vendor DFT tools.",
          "Create test plan for complex ASICs and drive the DFT implementation.",
          "Ability to guide people, multiplex many issues and set priorities."
        ]
      }
    ]
  },
  {
    "title": "RTL Engineers",
    "category": "technical",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "rtl",
    "sourceUrl": "https://www.digicommsemi.com/rtl.html",
    "description": [
      "Specification Interpretation: Collaborate with system architects to understand the high-level specifications and requirements for the digital design.",
      "RTL Design: Create RTL descriptions of digital circuits using hardware description languages (e.g., Verilog, SystemVerilog) to capture the desired functionality.",
      "Digital Logic Design: Implement digital logic functions, state machines, and control units to meet design goals for performance, power, and area (PPA).",
      "Synthesis Optimization: Work with synthesis tools (e.g., Synopsys Design Compiler, Cadence Genus) to optimize the RTL code for efficient gate-level implementation.",
      "Clock Domain Crossing (CDC) Analysis: Address clock domain crossing issues by synchronizing signals that cross different clock domains.",
      "Low-Power Design: Implement low-power design techniques, including clock gating, power gating, and voltage scaling, to reduce power consumption while maintaining functionality.",
      "Timing Analysis: Use static timing analysis (STA) tools to ensure that the design meets timing constraints and operates at the desired clock frequency.",
      "Simulation: Conduct functional simulation and RTL-level verification using simulation tools (e.g., ModelSim) to verify the correctness of the RTL code.",
      "Debugging: Identify and address issues in the RTL code and collaborate with cross-functional teams to resolve them.",
      "Documentation: Maintain comprehensive documentation of the RTL code, design constraints, and any design-specific considerations.",
      "IP Integration: Integrate digital IP blocks from internal or external sources into the overall design, ensuring compatibility and functionality.",
      "Collaboration: Collaborate closely with physical design, verification, and DFT (Design for Test) engineers to ensure successful integration of digital components into the complete IC design."
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Specification Interpretation: Collaborate with system architects to understand the high-level specifications and requirements for the digital design.",
          "RTL Design: Create RTL descriptions of digital circuits using hardware description languages (e.g., Verilog, SystemVerilog) to capture the desired functionality.",
          "Digital Logic Design: Implement digital logic functions, state machines, and control units to meet design goals for performance, power, and area (PPA).",
          "Synthesis Optimization: Work with synthesis tools (e.g., Synopsys Design Compiler, Cadence Genus) to optimize the RTL code for efficient gate-level implementation.",
          "Clock Domain Crossing (CDC) Analysis: Address clock domain crossing issues by synchronizing signals that cross different clock domains.",
          "Low-Power Design: Implement low-power design techniques, including clock gating, power gating, and voltage scaling, to reduce power consumption while maintaining functionality.",
          "Timing Analysis: Use static timing analysis (STA) tools to ensure that the design meets timing constraints and operates at the desired clock frequency.",
          "Simulation: Conduct functional simulation and RTL-level verification using simulation tools (e.g., ModelSim) to verify the correctness of the RTL code.",
          "Debugging: Identify and address issues in the RTL code and collaborate with cross-functional teams to resolve them.",
          "Documentation: Maintain comprehensive documentation of the RTL code, design constraints, and any design-specific considerations.",
          "IP Integration: Integrate digital IP blocks from internal or external sources into the overall design, ensuring compatibility and functionality.",
          "Collaboration: Collaborate closely with physical design, verification, and DFT (Design for Test) engineers to ensure successful integration of digital components into the complete IC design."
        ]
      }
    ]
  },
  {
    "title": "STA Engineer",
    "category": "technical",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "USA",
    "slug": "sta-engineer",
    "sourceUrl": "https://www.digicommsemi.com/sta-engineer.html",
    "description": [
      "Timing Constraint Generation: Work with design and architecture teams to define and generate timing constraints that specify the desired timing requirements for the design.",
      "STA Setup: Set up and configure STA tools (e.g., Cadence Encounter, Synopsys PrimeTime) for the analysis, including library characterization, delay models, and clock definitions.",
      "Timing Analysis: Perform static timing analysis to evaluate setup and hold times, clock-to-q delays, and other timing metrics. Ensure that the design meets timing requirements for various corners and operating conditions (e.g., process, voltage, temperature variations).",
      "Clock Domain Crossing (CDC) Analysis: Identify and analyze asynchronous signals crossing between different clock domains to ensure proper synchronization and to avoid metastability issues.",
      "Multicycle Paths (MCP) and False Paths: Define and analyze multicycle paths and false paths to accurately capture the design's timing constraints.",
      "Timing Closure: Collaborate with RTL and physical design teams to achieve timing closure by optimizing the design or constraints. Perform incremental and formal ECO (Engineering Change Order) analysis to address timing issues.",
      "Clock Tree Synthesis (CTS): Work with CTS engineers to ensure that the clock tree meets timing requirements and minimizes clock skew and jitter.",
      "Post-Layout STA: Perform post-layout STA to account for parasitic capacitance and resistance effects introduced during the physical design phase. Identify and resolve timing violations and sign-off on the final timing closure.",
      "Timing Margins: Analyze timing margins to account for variability and manufacturing process variations, ensuring robust operation.",
      "Report Generation: Prepare detailed timing analysis reports, including timing paths, violations, and suggestions for timing optimization.",
      "Cross-Functional Collaboration: Collaborate closely with RTL designers, physical designers, DFT (Design for Test) engineers, and verification teams to resolve timing-related issues.",
      "Methodology Development: Contribute to the development and improvement of STA methodologies and flows to enhance efficiency and accuracy."
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Timing Constraint Generation: Work with design and architecture teams to define and generate timing constraints that specify the desired timing requirements for the design.",
          "STA Setup: Set up and configure STA tools (e.g., Cadence Encounter, Synopsys PrimeTime) for the analysis, including library characterization, delay models, and clock definitions.",
          "Timing Analysis: Perform static timing analysis to evaluate setup and hold times, clock-to-q delays, and other timing metrics. Ensure that the design meets timing requirements for various corners and operating conditions (e.g., process, voltage, temperature variations).",
          "Clock Domain Crossing (CDC) Analysis: Identify and analyze asynchronous signals crossing between different clock domains to ensure proper synchronization and to avoid metastability issues.",
          "Multicycle Paths (MCP) and False Paths: Define and analyze multicycle paths and false paths to accurately capture the design's timing constraints.",
          "Timing Closure: Collaborate with RTL and physical design teams to achieve timing closure by optimizing the design or constraints. Perform incremental and formal ECO (Engineering Change Order) analysis to address timing issues.",
          "Clock Tree Synthesis (CTS): Work with CTS engineers to ensure that the clock tree meets timing requirements and minimizes clock skew and jitter.",
          "Post-Layout STA: Perform post-layout STA to account for parasitic capacitance and resistance effects introduced during the physical design phase. Identify and resolve timing violations and sign-off on the final timing closure.",
          "Timing Margins: Analyze timing margins to account for variability and manufacturing process variations, ensuring robust operation.",
          "Report Generation: Prepare detailed timing analysis reports, including timing paths, violations, and suggestions for timing optimization.",
          "Cross-Functional Collaboration: Collaborate closely with RTL designers, physical designers, DFT (Design for Test) engineers, and verification teams to resolve timing-related issues.",
          "Methodology Development: Contribute to the development and improvement of STA methodologies and flows to enhance efficiency and accuracy."
        ]
      }
    ]
  },
  {
    "title": "Std. Cell/ Layout Engineers",
    "category": "technical",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "std-layout-engineers",
    "sourceUrl": "https://www.digicommsemi.com/std-layout-engineers.html",
    "description": [
      "Standard Cell Library Development: Design and optimize standard cell libraries containing logic gates (e.g., AND, OR, NAND, NOR, Flip-Flops) with various drive strengths and functionality options.",
      "Cell Characterization: Characterize standard cells by performing static timing analysis (STA) to measure delay, power consumption, and other performance metrics under different process corners and operating conditions.",
      "Custom Cell Design: Create custom cells or specialized standard cells when needed for unique design requirements.",
      "Standard Cell Layout Design: Generate physical layouts for standard cells using layout design tools (e.g., Cadence Virtuoso, Synopsys IC Compiler).",
      "DRC and LVS Verification: Run design rule checking (DRC) and layout versus schematic (LVS) verification to ensure that the standard cell layouts adhere to manufacturing design rules and match their schematics.",
      "Library Characterization: Characterize and validate the standard cell library for various technology nodes, ensuring consistency and accuracy.",
      "Low-Power Design: Implement low-power standard cells with features like power gating and voltage scaling to optimize power consumption.",
      "Advanced Process Nodes: Address challenges specific to advanced process nodes, such as FinFET and multi-patterning, when designing and optimizing standard cells.",
      "Design for Manufacturability (DFM): Collaborate with manufacturing teams to ensure that standard cell layouts are manufacturable, considering lithography, process variation, and yield.",
      "Library Documentation: Maintain detailed documentation of standard cell libraries, including timing models, power models, and layout guidelines.",
      "Library Integration: Work with digital design teams to integrate standard cell libraries into the overall chip design."
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Standard Cell Library Development: Design and optimize standard cell libraries containing logic gates (e.g., AND, OR, NAND, NOR, Flip-Flops) with various drive strengths and functionality options.",
          "Cell Characterization: Characterize standard cells by performing static timing analysis (STA) to measure delay, power consumption, and other performance metrics under different process corners and operating conditions.",
          "Custom Cell Design: Create custom cells or specialized standard cells when needed for unique design requirements.",
          "Standard Cell Layout Design: Generate physical layouts for standard cells using layout design tools (e.g., Cadence Virtuoso, Synopsys IC Compiler).",
          "DRC and LVS Verification: Run design rule checking (DRC) and layout versus schematic (LVS) verification to ensure that the standard cell layouts adhere to manufacturing design rules and match their schematics.",
          "Library Characterization: Characterize and validate the standard cell library for various technology nodes, ensuring consistency and accuracy.",
          "Low-Power Design: Implement low-power standard cells with features like power gating and voltage scaling to optimize power consumption.",
          "Advanced Process Nodes: Address challenges specific to advanced process nodes, such as FinFET and multi-patterning, when designing and optimizing standard cells.",
          "Design for Manufacturability (DFM): Collaborate with manufacturing teams to ensure that standard cell layouts are manufacturable, considering lithography, process variation, and yield.",
          "Library Documentation: Maintain detailed documentation of standard cell libraries, including timing models, power models, and layout guidelines.",
          "Library Integration: Work with digital design teams to integrate standard cell libraries into the overall chip design."
        ]
      }
    ]
  },
  {
    "title": "SOC Emulation/Pre Si Verification Engineers",
    "category": "technical",
    "location": "Bengaluru/Hyderabad",
    "qualification": "BTECH/MTECH",
    "slug": "soc-emulationpre-si-verification-engineers",
    "sourceUrl": "https://www.digicommsemi.com/SOC-EmulationPre-Si-Verification-Engineers.html",
    "description": [
      "A good understanding of architectural aspects and RTL code at IP/Sub-system/SoC level.",
      "A good understanding of verification methodologies including SV-UVM/C based environment, transactors etc.",
      "A good understanding of verification methodologies including SV-UVM/C based environment, transactors etc.",
      "Experience in building emulation models from scratch.",
      "Knowledge of Arm CPU cores, protocols including PCIe, USB, Ethernet, AMBA, UART/SPI/I2C, DDR, flash memories and their usage in SoC environments is necessary.",
      "Emulation experience on ZeBu/Palladium, including compilation, test execution, debug, and performance.",
      "Strong scripting skills including UNIX shell scripting, Perl, TCL etc",
      "Support various emulation users.",
      "Must have worked in end-to-end Emulation of atleast 1-2 SoC programs in Sub-system and chip level."
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "A good understanding of architectural aspects and RTL code at IP/Sub-system/SoC level.",
          "A good understanding of verification methodologies including SV-UVM/C based environment, transactors etc.",
          "A good understanding of verification methodologies including SV-UVM/C based environment, transactors etc.",
          "Experience in building emulation models from scratch.",
          "Knowledge of Arm CPU cores, protocols including PCIe, USB, Ethernet, AMBA, UART/SPI/I2C, DDR, flash memories and their usage in SoC environments is necessary.",
          "Emulation experience on ZeBu/Palladium, including compilation, test execution, debug, and performance.",
          "Strong scripting skills including UNIX shell scripting, Perl, TCL etc",
          "Support various emulation users.",
          "Must have worked in end-to-end Emulation of atleast 1-2 SoC programs in Sub-system and chip level."
        ]
      }
    ]
  },
  {
    "title": "Talent Acquisition Executive",
    "category": "hr",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "talent-acquisition-executive",
    "sourceUrl": "https://www.digicommsemi.com/talent-acquisition-executive.html",
    "description": [
      "Proven work experience of 2+ years as a Talent Acquisition Specialist or a similar role in the semiconductor industry.",
      "Familiarity with social media, resume databases and professional networks.",
      "Hands on experience with full cycle recruiting using various interview techniques and evaluation methods.",
      "Excellent verbal and written communication skills.",
      "Familiarity with ASIC design flow and layout automation",
      "Talent acquisition responsibilities includes sourcing through various channels, planning interview and selection procedures and hosting or participating in career events",
      "Coordinate with hiring managers to identify staffing needs.",
      "Determine Selection criteria",
      "Source potential candidates through online channels (e;g. Social platforms and professional networks)",
      "Plan interview and selection procedures including screening calls, assessments and interviews.",
      "Asses candidate information, including resumes and contact details using our applicant tracking system",
      "Foster long term relationships with potential candidates."
    ],
    "sections": [
      {
        "title": "Requirements and Skills",
        "items": [
          "Proven work experience of 2+ years as a Talent Acquisition Specialist or a similar role in the semiconductor industry.",
          "Familiarity with social media, resume databases and professional networks.",
          "Hands on experience with full cycle recruiting using various interview techniques and evaluation methods.",
          "Excellent verbal and written communication skills.",
          "Familiarity with ASIC design flow and layout automation"
        ]
      },
      {
        "title": "Roles and Responsibilities",
        "items": [
          "Talent acquisition responsibilities includes sourcing through various channels, planning interview and selection procedures and hosting or participating in career events",
          "Coordinate with hiring managers to identify staffing needs.",
          "Determine Selection criteria",
          "Source potential candidates through online channels (e;g. Social platforms and professional networks)",
          "Plan interview and selection procedures including screening calls, assessments and interviews.",
          "Asses candidate information, including resumes and contact details using our applicant tracking system",
          "Foster long term relationships with potential candidates."
        ]
      }
    ]
  },
  {
    "title": "Senior Talent Acquisition Executive",
    "category": "hr",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "sr-talent-acquisition-executive",
    "sourceUrl": "https://www.digicommsemi.com/sr-talent-acquisition-executive.html",
    "description": [
      "Proven work experience of 4+ years as a Talent Acquisition Specialist or a similar role in the semiconductor industry.",
      "Should have worked in different domains of the VLSI industry.",
      "Strong Linked connections is preferred.",
      "Familiarity with social media, resume databases and professional networks.",
      "Hands on experience with full cycle recruiting using various interview techniques and evaluation methods",
      "Excellent verbal and written communication skills.",
      "Ability to handle the Junior Executives as a Team",
      "Must have ability to initiate, lead and work without supervisions.",
      "Talent acquisition responsibilities includes sourcing through various channels, planning interview and selection procedures and hosting or participating in career events",
      "Coordinate with hiring managers to identify staffing needs.",
      "Determine Selection criteria",
      "Source potential candidates through online channels (e;g. Social platforms and professional networks)",
      "Plan interview and selection procedures including screening calls, assessments and interviews.",
      "Asses candidate information, including resumes and contact details using our applicant tracking system.",
      "Lead employer branding initiates.",
      "Foster long term relationships with potential candidates."
    ],
    "sections": [
      {
        "title": "Requirements and Skills",
        "items": [
          "Proven work experience of 4+ years as a Talent Acquisition Specialist or a similar role in the semiconductor industry.",
          "Should have worked in different domains of the VLSI industry.",
          "Strong Linked connections is preferred.",
          "Familiarity with social media, resume databases and professional networks.",
          "Hands on experience with full cycle recruiting using various interview techniques and evaluation methods",
          "Excellent verbal and written communication skills.",
          "Ability to handle the Junior Executives as a Team",
          "Must have ability to initiate, lead and work without supervisions."
        ]
      },
      {
        "title": "Roles and Responsibilities",
        "items": [
          "Talent acquisition responsibilities includes sourcing through various channels, planning interview and selection procedures and hosting or participating in career events",
          "Coordinate with hiring managers to identify staffing needs.",
          "Determine Selection criteria",
          "Source potential candidates through online channels (e;g. Social platforms and professional networks)",
          "Plan interview and selection procedures including screening calls, assessments and interviews.",
          "Asses candidate information, including resumes and contact details using our applicant tracking system.",
          "Lead employer branding initiates.",
          "Foster long term relationships with potential candidates."
        ]
      }
    ]
  },
  {
    "title": "Embedded Systems Engineer",
    "category": "technical",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "embedded-systems-engineer",
    "sourceUrl": "https://www.digicommsemi.com/Embedded%20Systems%20Engineer.html",
    "description": [
      "Strong proficiency in Embedded C/C++",
      "Solid experience in working with RTOS (task scheduling, semaphores, mutexes, ISRs, etc.)",
      "Hands-on experience with low-level microcontroller programming.",
      "Familiarity with communication protocols (I2C, SPI, UART, CAN, Modbus, etc.)",
      "Experience in using version control (Git), and debugging tools (JTAG, GDB, etc.)",
      "Familiarity with reading schematics and working with hardware teams.",
      "Digital electronics ( Latches, Gates, Adders, Flipflops) knowledge is added advantage - Do mention this while sharing."
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Strong proficiency in Embedded C/C++",
          "Solid experience in working with RTOS (task scheduling, semaphores, mutexes, ISRs, etc.)",
          "Hands-on experience with low-level microcontroller programming.",
          "Familiarity with communication protocols (I2C, SPI, UART, CAN, Modbus, etc.)",
          "Experience in using version control (Git), and debugging tools (JTAG, GDB, etc.)",
          "Familiarity with reading schematics and working with hardware teams.",
          "Digital electronics ( Latches, Gates, Adders, Flipflops) knowledge is added advantage - Do mention this while sharing."
        ]
      }
    ]
  },
  {
    "title": "H.R Manager",
    "category": "hr",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "hr-manager",
    "sourceUrl": "https://www.digicommsemi.com/hr-manager.html",
    "description": [
      "Bachelor\u2019s or Master\u2019s Degree in Human Resources Management or related discipline",
      "5+ years\u2019 experience in HR",
      "Expertise in HR policies and procedures",
      "Understanding of HR best practices and current regulations",
      "Sound judgment and problem-solving skills",
      "Customer-focused attitude, with high level of professionalism and discretion",
      "Familiarity with MS Office suite",
      "Excellent communication skills",
      "Implement and administer employee policies",
      "Provide high-quality advice and service to management on daily employee relations and performance management issues",
      "Support the HR department in implementing programs to help improve the employee experience",
      "Offer proactive recruiting assistance",
      "Identify ways to improve policies and procedures",
      "Prepare termination and severance letters",
      "Train and provide support to HR team members"
    ],
    "sections": [
      {
        "title": "Requirements and Skills",
        "items": [
          "Bachelor\u2019s or Master\u2019s Degree in Human Resources Management or related discipline",
          "5+ years\u2019 experience in HR",
          "Expertise in HR policies and procedures",
          "Understanding of HR best practices and current regulations",
          "Sound judgment and problem-solving skills",
          "Customer-focused attitude, with high level of professionalism and discretion",
          "Familiarity with MS Office suite",
          "Excellent communication skills"
        ]
      },
      {
        "title": "Roles and Responsibilities",
        "items": [
          "Implement and administer employee policies",
          "Provide high-quality advice and service to management on daily employee relations and performance management issues",
          "Support the HR department in implementing programs to help improve the employee experience",
          "Offer proactive recruiting assistance",
          "Identify ways to improve policies and procedures",
          "Prepare termination and severance letters",
          "Train and provide support to HR team members"
        ]
      }
    ]
  },
  {
    "title": "Business Development Manager",
    "category": "business",
    "location": "India/ Taiwan/ USA",
    "qualification": "BTECH/MTECH",
    "slug": "business-development-manager",
    "sourceUrl": "https://www.digicommsemi.com/Business-Development-Manager.html",
    "description": [
      "Creating, administering, and implementing winning business development strategies that the company should pursue.",
      "Identifying, evaluating, and conducting follow-up on sales leads to closing the deal.",
      "Leading various marketing strategies like social media marketing, content marketing, cold calling, emailing, and other strategies to develop viable leads that can be converted to successful clients.",
      "Representing the organization in various functions like conferences, showcases, and seminars to create awareness about organization products and generate potential leads.",
      "Developing and nurturing relationships with various key strategic individuals like local leaders, key industry players, and strategic suppliers and financing organizations.",
      "To oversee and implement the full sales cycle which involves market research, market analysis, pitching to various prospects, and client retention.",
      "Tracking and reporting on the various marketing strategies to improve on the winning strategies, adjust the ineffective strategies, or change to a new strategy.",
      "Establishing the sales metrics and goals for various players in the marketing department including the head of marketing, business development officers, and sales consultants.",
      "Bachelor\u2019s degree in marketing or any business-related field",
      "Preferably Master\u2019s in business administration (MBA)",
      "Minimum of 3+ years to 20 years of experience in BD",
      "Strong background in the marketing field",
      "Comfortable and confident using technology as an integral part of the sales process, including Salesforce",
      "Experience and deep knowledge in Digital Marketing",
      "Outgoing individual with high negotiating skills to be able to initiate and close business deals.",
      "Proven technical skills in their area of specialty",
      "Product knowledge is critical for business development.",
      "Strong leadership and managerial skills",
      "Possess the reliable problem-solving ability",
      "Excellent written and communication skills",
      "High level of organizational skills with the ability to work under pressure"
    ],
    "sections": [
      {
        "title": "Roles and Responsibilities",
        "items": [
          "Creating, administering, and implementing winning business development strategies that the company should pursue.",
          "Identifying, evaluating, and conducting follow-up on sales leads to closing the deal.",
          "Leading various marketing strategies like social media marketing, content marketing, cold calling, emailing, and other strategies to develop viable leads that can be converted to successful clients.",
          "Representing the organization in various functions like conferences, showcases, and seminars to create awareness about organization products and generate potential leads.",
          "Developing and nurturing relationships with various key strategic individuals like local leaders, key industry players, and strategic suppliers and financing organizations.",
          "To oversee and implement the full sales cycle which involves market research, market analysis, pitching to various prospects, and client retention.",
          "Tracking and reporting on the various marketing strategies to improve on the winning strategies, adjust the ineffective strategies, or change to a new strategy.",
          "Establishing the sales metrics and goals for various players in the marketing department including the head of marketing, business development officers, and sales consultants."
        ]
      },
      {
        "title": "Requirements and Skills",
        "items": [
          "Bachelor\u2019s degree in marketing or any business-related field",
          "Preferably Master\u2019s in business administration (MBA)",
          "Minimum of 3+ years to 20 years of experience in BD",
          "Strong background in the marketing field",
          "Comfortable and confident using technology as an integral part of the sales process, including Salesforce",
          "Experience and deep knowledge in Digital Marketing",
          "Outgoing individual with high negotiating skills to be able to initiate and close business deals.",
          "Proven technical skills in their area of specialty",
          "Product knowledge is critical for business development.",
          "Strong leadership and managerial skills",
          "Possess the reliable problem-solving ability",
          "Excellent written and communication skills",
          "High level of organizational skills with the ability to work under pressure"
        ]
      }
    ]
  },
  {
    "title": "Trained & Fresher Candidates",
    "category": "opportunities",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "freshers-intermediates-form",
    "sourceUrl": "https://www.digicommsemi.com/freshers-intermediates-form.html",
    "description": [
      "Job Role: PD, DV, STA, DFT, RTL, Analog etc.",
      "Total Number of Vacancy : Multiple",
      "Salary on Role: Best in industry"
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Job Role: PD, DV, STA, DFT, RTL, Analog etc.",
          "Total Number of Vacancy : Multiple",
          "Salary on Role: Best in industry"
        ]
      }
    ]
  },
  {
    "title": "Internship",
    "category": "opportunities",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "MBA",
    "slug": "internship",
    "sourceUrl": "https://www.digicommsemi.com/internship.html",
    "description": [],
    "sections": []
  },
  {
    "title": "Senior Physical Design Engineers",
    "category": "technical",
    "location": "USA/ Austin/ Texas",
    "qualification": "BTECH/MTECH",
    "slug": "physical-design-engineer-usa",
    "sourceUrl": "https://www.digicommsemi.com/physical-design-engineer_USA.html",
    "description": [
      "Analyze the design and divide into small blocks.",
      "Split the circuit such that the number of connections between partitions is minimized.",
      "Based on the design analysis identifying appropriate place for different blocks within the chip area.",
      "Allocating places for external Hard IPs.",
      "Placing and optimizing the various small blocks identified during partitioning process:",
      "Pre-placement optimization",
      "Post Placement Optimization (PPO) before clock tree synthesis (CTS)",
      "Routing the various clock signals within the design so that the clock skews are optimized:",
      "Clock Tree Synthesis (CTS)",
      "PPO after CTS",
      "Perform the STA, across the complete design to ensure that all the timing checks are clean:",
      "Constraint Generation",
      "Budgeting",
      "Timing Sign off, IR/EM Analysis",
      "Xtalk, Noise",
      "Signal integrity",
      "Perform Physical Verification against various critical parameters & criteria:",
      "Layout Vs Schematic Checks (LVS)",
      "Design Rule Checks (DRC)",
      "Electrical Rule Checks (ERC)",
      "EEC & ESD (Electrostatic Discharge Check)",
      "Antenna Checks",
      "OPC, CMP, Yield etc"
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Analyze the design and divide into small blocks.",
          "Split the circuit such that the number of connections between partitions is minimized.",
          "Based on the design analysis identifying appropriate place for different blocks within the chip area.",
          "Allocating places for external Hard IPs.",
          "Placing and optimizing the various small blocks identified during partitioning process:",
          "Pre-placement optimization",
          "Post Placement Optimization (PPO) before clock tree synthesis (CTS)",
          "Routing the various clock signals within the design so that the clock skews are optimized:",
          "Clock Tree Synthesis (CTS)",
          "PPO after CTS",
          "Perform the STA, across the complete design to ensure that all the timing checks are clean:",
          "Constraint Generation",
          "Budgeting",
          "Timing Sign off, IR/EM Analysis",
          "Xtalk, Noise",
          "Signal integrity",
          "Perform Physical Verification against various critical parameters & criteria:",
          "Layout Vs Schematic Checks (LVS)",
          "Design Rule Checks (DRC)",
          "Electrical Rule Checks (ERC)",
          "EEC & ESD (Electrostatic Discharge Check)",
          "Antenna Checks",
          "OPC, CMP, Yield etc"
        ]
      }
    ]
  },
  {
    "title": "Lead Physical Design Engineers",
    "category": "technical",
    "location": "USA/ Austin/ Texas",
    "qualification": "BTECH/MTECH",
    "slug": "physical-design-engineer-usalead",
    "sourceUrl": "https://www.digicommsemi.com/physical-design-engineer_USALead.html",
    "description": [
      "Analyze the design and divide into small blocks.",
      "Split the circuit such that the number of connections between partitions is minimized.",
      "Based on the design analysis identifying appropriate place for different blocks within the chip area.",
      "Allocating places for external Hard IPs.",
      "Placing and optimizing the various small blocks identified during partitioning process:",
      "Pre-placement optimization",
      "Post Placement Optimization (PPO) before clock tree synthesis (CTS)",
      "Routing the various clock signals within the design so that the clock skews are optimized:",
      "Clock Tree Synthesis (CTS)",
      "PPO after CTS",
      "Perform the STA, across the complete design to ensure that all the timing checks are clean:",
      "Constraint Generation",
      "Budgeting",
      "Timing Sign off, IR/EM Analysis",
      "Xtalk, Noise",
      "Signal integrity",
      "Perform Physical Verification against various critical parameters & criteria:",
      "Layout Vs Schematic Checks (LVS)",
      "Design Rule Checks (DRC)",
      "Electrical Rule Checks (ERC)",
      "EEC & ESD (Electrostatic Discharge Check)",
      "Antenna Checks",
      "OPC, CMP, Yield etc"
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Analyze the design and divide into small blocks.",
          "Split the circuit such that the number of connections between partitions is minimized.",
          "Based on the design analysis identifying appropriate place for different blocks within the chip area.",
          "Allocating places for external Hard IPs.",
          "Placing and optimizing the various small blocks identified during partitioning process:",
          "Pre-placement optimization",
          "Post Placement Optimization (PPO) before clock tree synthesis (CTS)",
          "Routing the various clock signals within the design so that the clock skews are optimized:",
          "Clock Tree Synthesis (CTS)",
          "PPO after CTS",
          "Perform the STA, across the complete design to ensure that all the timing checks are clean:",
          "Constraint Generation",
          "Budgeting",
          "Timing Sign off, IR/EM Analysis",
          "Xtalk, Noise",
          "Signal integrity",
          "Perform Physical Verification against various critical parameters & criteria:",
          "Layout Vs Schematic Checks (LVS)",
          "Design Rule Checks (DRC)",
          "Electrical Rule Checks (ERC)",
          "EEC & ESD (Electrostatic Discharge Check)",
          "Antenna Checks",
          "OPC, CMP, Yield etc"
        ]
      }
    ]
  },
  {
    "title": "Employee Referral Form",
    "category": "opportunities",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "employee-referral-form",
    "sourceUrl": "https://www.digicommsemi.com/employee-referral-form.html",
    "description": [],
    "sections": []
  },
  {
    "title": "Memory Layout Engineer",
    "category": "technical",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "memory-layout-engineer",
    "sourceUrl": "https://www.digicommsemi.com/memory-layout-engineer.html",
    "description": [
      "Experience or strong interest in developing memory compilers, addressing layout-related issues, and ensuring optimization.",
      "Excellent problem-solving skills in Routing Congestion, Physical Verification in Custom Layout.",
      "Sound knowledge and experience for verification checks like DRC / LVS / ERC / Antenna / LPE / DFM etc.",
      "Knowledge of various analog layout techniques, understanding of various circuit principles as affected by Layouts such as speed, capacitance, power, noise, and area.",
      "Excellent hands-on experience in industry standard layout and verification tools in a Linux environment of Cadence and Mentor EDA tools. Power user of VirtuosoXL.",
      "Excellent Leadership skills and Mentor & guide team members in execution of Layout and review their work outputs for quality and delivery Excellent communication skills and proactive at work.",
      "Excellent communication skills and proactive at work"
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Experience or strong interest in developing memory compilers, addressing layout-related issues, and ensuring optimization.",
          "Excellent problem-solving skills in Routing Congestion, Physical Verification in Custom Layout.",
          "Sound knowledge and experience for verification checks like DRC / LVS / ERC / Antenna / LPE / DFM etc.",
          "Knowledge of various analog layout techniques, understanding of various circuit principles as affected by Layouts such as speed, capacitance, power, noise, and area.",
          "Excellent hands-on experience in industry standard layout and verification tools in a Linux environment of Cadence and Mentor EDA tools. Power user of VirtuosoXL.",
          "Excellent Leadership skills and Mentor & guide team members in execution of Layout and review their work outputs for quality and delivery Excellent communication skills and proactive at work.",
          "Excellent communication skills and proactive at work"
        ]
      }
    ]
  },
  {
    "title": "Software Developer",
    "category": "technical",
    "location": "Irvine California USA",
    "qualification": "BTECH/MTECH",
    "slug": "software-developer",
    "sourceUrl": "https://www.digicommsemi.com/Software%20developer.html",
    "description": [
      "A world-class team responsible for designing and supporting some of the coolest products in millions of homes and businesses around the world. The engineer in this position will join a team of highly competent firmware developers involved in the design, implementation and verification of firmware and software for embedded systems. The successful candidate will architect, design, implement and support low level firmware modules, middle ware, sample applications as well as diagnostics embedded software. To succeed in this role, you must be a knowledgeable embedded engineer with excellent teamwork and problem solving skills. You will have the opportunity to work with a talented team of embedded software engineers and be a part of the firmware development cycle of leading-edge optical phy chip sets. In this position you would be responsible for ongoing development of features for our range of embedded products. Responsibilities include; design / implementation / testing and maintenance for existing and new products. If you have a passion for advancing technology and an insatiable desire to win, we encourage you to apply for these exciting opportunities.",
      "Software design, development of new products and maintenance of the legacy products.",
      "Work often involves cross functional system, analog and digital hardware designer teams.",
      "Troubleshoots code for firmware (embedded C code) applications.",
      "Provide leadership and expertise in the development of standards, architectural governance, design patterns, and code hygiene practices.",
      "Strong software development and documentation skills",
      "Proven ability in developing using C and ARM Assembly on embedded targets",
      "Good understanding of programming for real-time systems",
      "Understanding of multithreading and concurrent programming",
      "Experience with multiprocessor programming and inter-processor communication",
      "Driver experience (MDIO, I2C, SPI, etc.)",
      "Strong debugging skills",
      "Experience with ARM processors",
      "Software development on Windows using the Visual C/C++ environment",
      "Software development on Linux systems in a Linux environment",
      "Understanding of restrictions when interfacing proprietary software with GPL, LGPL, and ASL licensed components",
      "Excellent communication skills and proactive at work"
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "A world-class team responsible for designing and supporting some of the coolest products in millions of homes and businesses around the world. The engineer in this position will join a team of highly competent firmware developers involved in the design, implementation and verification of firmware and software for embedded systems. The successful candidate will architect, design, implement and support low level firmware modules, middle ware, sample applications as well as diagnostics embedded software. To succeed in this role, you must be a knowledgeable embedded engineer with excellent teamwork and problem solving skills. You will have the opportunity to work with a talented team of embedded software engineers and be a part of the firmware development cycle of leading-edge optical phy chip sets. In this position you would be responsible for ongoing development of features for our range of embedded products. Responsibilities include; design / implementation / testing and maintenance for existing and new products. If you have a passion for advancing technology and an insatiable desire to win, we encourage you to apply for these exciting opportunities.",
          "Software design, development of new products and maintenance of the legacy products.",
          "Work often involves cross functional system, analog and digital hardware designer teams.",
          "Troubleshoots code for firmware (embedded C code) applications.",
          "Provide leadership and expertise in the development of standards, architectural governance, design patterns, and code hygiene practices.",
          "Strong software development and documentation skills",
          "Proven ability in developing using C and ARM Assembly on embedded targets",
          "Good understanding of programming for real-time systems",
          "Understanding of multithreading and concurrent programming",
          "Experience with multiprocessor programming and inter-processor communication",
          "Driver experience (MDIO, I2C, SPI, etc.)",
          "Strong debugging skills",
          "Experience with ARM processors",
          "Software development on Windows using the Visual C/C++ environment",
          "Software development on Linux systems in a Linux environment",
          "Understanding of restrictions when interfacing proprietary software with GPL, LGPL, and ASL licensed components",
          "Excellent communication skills and proactive at work"
        ]
      }
    ]
  },
  {
    "title": "PCB Design Engineer",
    "category": "technical",
    "location": "Bengaluru/ Pune/ Hyderabad/ Noida",
    "qualification": "BTECH/MTECH",
    "slug": "pcb-design-engineer",
    "sourceUrl": "https://www.digicommsemi.com/PCB%20Design%20Engineer.html",
    "description": [
      "Design schematics and PCB layouts for high-speed, multilayer boards (4\u201316 layers or more).",
      "Work on VLIS system boards, FPGA boards, processor modules, and mixed-signal circuits.",
      "Placement & routing of high-speed signals, including DDR, PCIe, USB, HDMI, LVDS, SERDES, and RF lines.",
      "Create footprints, symbols, and libraries as per IPC standards.",
      "Expert in tools like Altium Designer, Cadence Allegro/OrCAD, Mentor Xpedition, KiCad (depending on need).",
      "Use simulation tools for Signal Integrity (SI), Power Integrity (PI), and thermal analysis.",
      "Use simulation tools for Signal Integrity (SI), Power Integrity (PI), and thermal analysis."
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Design schematics and PCB layouts for high-speed, multilayer boards (4\u201316 layers or more).",
          "Work on VLIS system boards, FPGA boards, processor modules, and mixed-signal circuits.",
          "Placement & routing of high-speed signals, including DDR, PCIe, USB, HDMI, LVDS, SERDES, and RF lines.",
          "Create footprints, symbols, and libraries as per IPC standards.",
          "Expert in tools like Altium Designer, Cadence Allegro/OrCAD, Mentor Xpedition, KiCad (depending on need).",
          "Use simulation tools for Signal Integrity (SI), Power Integrity (PI), and thermal analysis.",
          "Use simulation tools for Signal Integrity (SI), Power Integrity (PI), and thermal analysis."
        ]
      }
    ]
  },
  {
    "title": "Senior DFT Engineers",
    "category": "technical",
    "location": "USA/ Austin/ Texas",
    "qualification": "BTECH/MTECH",
    "slug": "dft-engineer-usa",
    "sourceUrl": "https://www.digicommsemi.com/dft-engineer_USA.html",
    "description": [
      "Analyze the design.",
      "Top Level Test Pin Planning.",
      "MBIST Insertion, & Optimization.",
      "Scan Insertion, Scan Compression.",
      "Check scan insertion results.",
      "Run formal verification between synthesized netlist and post DFT netlist.",
      "Generate DFT constraints for backend and Primetime.",
      "Provide BE team with post DFT netlist and associated constraints.",
      "Validation plan and test development.",
      "Generate ATPG Test Patterns.",
      "Block level and soc level patten generation.",
      "SOC level pattern re-target.",
      "Monitor test coverage and pattern counts.",
      "Run ATPG and pattern verification on DFT inserted netlist",
      "Block level pattern no timing simulation.",
      "SOC level pattern simulation.",
      "Block level timing simulation.",
      "MBIST pattern RTL and gate level validation.",
      "Run full MBIST, scan pattern generation and verification (both pre and post layout netlist)",
      "After chip top netlist is available, all block MBIST, scan pattern generation and verification should be run from top level.",
      "Firmware and API development.",
      "Hardware/system debug."
    ],
    "sections": [
      {
        "title": "Job Description",
        "items": [
          "Analyze the design.",
          "Top Level Test Pin Planning.",
          "MBIST Insertion, & Optimization.",
          "Scan Insertion, Scan Compression.",
          "Check scan insertion results.",
          "Run formal verification between synthesized netlist and post DFT netlist.",
          "Generate DFT constraints for backend and Primetime.",
          "Provide BE team with post DFT netlist and associated constraints.",
          "Validation plan and test development.",
          "Generate ATPG Test Patterns.",
          "Block level and soc level patten generation.",
          "SOC level pattern re-target.",
          "Monitor test coverage and pattern counts.",
          "Run ATPG and pattern verification on DFT inserted netlist",
          "Block level pattern no timing simulation.",
          "SOC level pattern simulation.",
          "Block level timing simulation.",
          "MBIST pattern RTL and gate level validation.",
          "Run full MBIST, scan pattern generation and verification (both pre and post layout netlist)",
          "After chip top netlist is available, all block MBIST, scan pattern generation and verification should be run from top level.",
          "Firmware and API development.",
          "Hardware/system debug."
        ]
      }
    ]
  }
];
